module.exports = __webpack_public_path__ + "img/ltkshoecrush-2x.ed6d8b4.jpg";